import { __decorate, __param } from 'tslib';
import { ElementRef, Inject, Directive, NgModule } from '@angular/core';

import * as ɵngcc0 from '@angular/core';
let TuiElementDirective = class TuiElementDirective extends ElementRef {
    constructor({ nativeElement }) {
        super(nativeElement);
    }
};
TuiElementDirective.ɵfac = function TuiElementDirective_Factory(t) { return new (t || TuiElementDirective)(ɵngcc0.ɵɵdirectiveInject(ElementRef)); };
TuiElementDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: TuiElementDirective, selectors: [["", "tuiElement", ""]], exportAs: ["elementRef"], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
TuiElementDirective.ctorParameters = () => [
    { type: ElementRef, decorators: [{ type: Inject, args: [ElementRef,] }] }
];
TuiElementDirective = __decorate([ __param(0, Inject(ElementRef))
], TuiElementDirective);

let TuiElementModule = class TuiElementModule {
};
TuiElementModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: TuiElementModule });
TuiElementModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function TuiElementModule_Factory(t) { return new (t || TuiElementModule)(); } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiElementDirective, [{
        type: Directive,
        args: [{
                selector: '[tuiElement]',
                exportAs: 'elementRef'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef, decorators: [{
                type: Inject,
                args: [ElementRef]
            }] }]; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiElementModule, { declarations: [TuiElementDirective], exports: [TuiElementDirective] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiElementModule, [{
        type: NgModule,
        args: [{
                declarations: [TuiElementDirective],
                exports: [TuiElementDirective]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { TuiElementDirective, TuiElementModule };

//# sourceMappingURL=taiga-ui-cdk-directives-element.js.map